<template>
  <div class="px-4 sm:px-6 lg:px-8 bg-gray-800">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto text-left">
        <h1 class="text-xl font-semibold text-white">Export data</h1>
        <p class="mt-2 text-sm text-gray-400">Export all data to firebase</p>
      </div>
<!-- 
      <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
        <button
          @click.prevent="showDuplicated()"
          class="ml-3 mr-2 inline-flex justify-center rounded-md border border-transparent bg-indigo-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
        >
          duplicated
        </button>
        <button
          @click.prevent="open('NewTag')"
          type="button"
          class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:w-auto"
        >
          new tag
        </button>
      </div> -->
    </div>

    <!-- <div class="sm:flex sm:items-center">
      {{ dane.length }}
    </div> -->




    <div class="sm:flex sm:items-center">
      <button
        @click.prevent="exportAllInOneToFirebase()"
        type="button"
        :disabled="isExporting"
        :class="[
          'inline-flex mt-2 items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:w-auto',
          isExporting 
            ? 'bg-gray-500 text-gray-300 cursor-not-allowed' 
            : 'bg-yellow-500 text-black hover:bg-yellow-600'
        ]"
      >
        {{ isExporting ? 'Exporting...' : 'export All-In-One to Firebase (zaloguj sie)' }}
      </button>
      <button
        @click.prevent="exportFilteredToFirebase(['ksiazulo', 'BIGWOJEK', 'Ksiazulo', 'BigWojek'])"
        type="button"
        :disabled="isExporting"
        :class="[
          'ml-4 inline-flex mt-2 items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 sm:w-auto',
          isExporting 
            ? 'bg-gray-500 cursor-not-allowed' 
            : 'bg-red-500 hover:bg-red-600'
        ]"
      >
        {{ isExporting ? 'Exporting...' : 'Export Ksiazulo & BIGWOJEK' }}
      </button>
    </div>

   <!-- Progress Bar -->
   <div v-if="isExporting" class="mt-4">
      <div class="flex items-center justify-between mb-2">
        <span class="text-sm font-medium text-white">Progress: {{ currentProgress }} / {{ totalItems }}</span>
        <span class="text-sm text-gray-400">{{ Math.round((currentProgress / totalItems) * 100) }}%</span>
      </div>
      <div class="w-full bg-gray-700 rounded-full h-2.5">
        <div 
          class="bg-yellow-500 h-2.5 rounded-full transition-all duration-300" 
          :style="{ width: `${(currentProgress / totalItems) * 100}%` }"
        ></div>
      </div>
      <div class="mt-2 text-sm text-gray-400">
        Processing: {{ currentItemTitle || 'Loading...' }}
      </div>
    </div>


    <div class="sm:flex sm:items-center mt-24">
      <button
        @click.prevent="exportToFirebase()"
        type="button"
        class="inline-flex mt-2 items-center justify-center rounded-md border border-transparent bg-indigo-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:w-auto"
      >
        ({{ dane.length }}) export to firebase
      </button>
    </div>

    <div class="sm:flex sm:items-center">
      <button
        @click.prevent="getTestDocument()"
        type="button"
        class="inline-flex mt-2 items-center justify-center rounded-md border border-transparent bg-indigo-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:w-auto"
      >
        get TEST doc and console.log
      </button>
    </div>



 

    <div class="sm:flex sm:items-center">
      <button
        @click.prevent="getAllSavedToFirebase()"
        type="button"
        class="inline-flex mt-2 items-center justify-center rounded-md border border-transparent bg-indigo-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:w-auto"
      >
        get All Saved To Firebase and console.log
      </button>
    </div>
    <div class="sm:flex sm:items-center">
      <button
        @click.prevent="updateGoogleRatings()"
        type="button"
        :disabled="isUpdatingRatings"
        :class="[
          'inline-flex mt-2 items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:w-auto',
          isUpdatingRatings 
            ? 'bg-gray-500 cursor-not-allowed' 
            : 'bg-indigo-700 hover:bg-indigo-800'
        ]"
      >
        {{ isUpdatingRatings ? 'Updating...' : 'update Google Ratings' }}
      </button>

      <button
        @click.prevent="updateGoogleRatingsTest()"
        type="button"
        :disabled="isUpdatingRatings"
        class="inline-flex mt-2 ml-4 items-center justify-center rounded-md border border-transparent bg-green-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 sm:w-auto"
      >
        update Google Ratings - 10 items
      </button>
    </div>

    <!-- Progress Bar for Ratings Update -->
    <div v-if="isUpdatingRatings" class="mt-4">
      <div class="flex items-center justify-between mb-2">
        <span class="text-sm font-medium text-white">Progress: {{ ratingsUpdateProgress }} / {{ ratingsUpdateTotal }}</span>
        <span class="text-sm text-gray-400">{{ Math.round((ratingsUpdateProgress / ratingsUpdateTotal) * 100) }}%</span>
      </div>
      <div class="w-full bg-gray-700 rounded-full h-2.5">
        <div 
          class="bg-blue-500 h-2.5 rounded-full transition-all duration-300" 
          :style="{ width: `${(ratingsUpdateProgress / ratingsUpdateTotal) * 100}%` }"
        ></div>
      </div>
      <div class="mt-2 text-sm text-gray-400">
        Processing: {{ ratingsUpdateCurrentItem || 'Starting...' }}
      </div>
    </div>

    <div class="sm:flex sm:items-center">
      <button
        @click.prevent="exportArticlesToFirebase()"
        type="button"
        class="inline-flex mt-2 items-center justify-center rounded-md border border-transparent bg-orange-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:w-auto"
      >
      export Articles to firebase
      </button>
    </div>


    <div class="sm:flex sm:items-center">
      <button
        @click.prevent="printAllArticles()"
        type="button"
        class="inline-flex mt-2 items-center justify-center rounded-md border border-transparent bg-orange-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:w-auto"
      >
      print All Articles
      </button>
    </div>

    <div class="sm:flex sm:items-center mt-5 border-t border-gray-700 pt-5">
      <button
        @click="toggleCidLinks"
        type="button"
        class="inline-flex items-center justify-center rounded-md border border-transparent bg-teal-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 sm:w-auto"
      >
        {{ showCidLinks ? 'Ukryj' : 'Pokaż' }} lokale z CID
      </button>
    </div>

    <!-- Table for CID Links -->
    <div v-if="showCidLinks" class="mt-8">
      <h2 class="text-lg font-semibold text-white">
        Lokale z numerem CID ({{ placesWithCid.length }})
      </h2>
      <div class="mt-4 flow-root">
        <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
          >
            <table class="min-w-full divide-y divide-gray-700">
              <thead>
                <tr>
                  <th
                    scope="col"
                    class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-white sm:pl-0"
                  >
                    Nazwa lokalu
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-white"
                  >
                    Link Google Maps
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-800">
                <tr v-for="item in placesWithCid" :key="item.id">
                  <td
                    class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-white sm:pl-0"
                  >
                    {{ item.title }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-300">
                    <a
                      :href="`https://www.google.com/maps/place/?q=place_id:${item.gid}`"
                      target="_blank"
                      class="text-indigo-400 hover:text-indigo-300"
                    >
                      {{ `https://www.google.com/maps/place/?q=place_id:${item.gid}` }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive, computed } from "vue";
import { apiFetch } from "../composables/apiClient";
import { auth } from "../firebase/config";
import { useRoute, useRouter } from "vue-router";

import addDocumentWithId from "../composables/addDocumentWithId.js";
import getDocById from "../composables/getDocById.js";

const router = useRouter();

const dane = ref([]);

// Progress tracking variables
const isExporting = ref(false);
const currentProgress = ref(0);
const totalItems = ref(0);
const currentItemTitle = ref('');

const isUpdatingRatings = ref(false);
const ratingsUpdateProgress = ref(0);
const ratingsUpdateTotal = ref(0);
const ratingsUpdateCurrentItem = ref('');

const showCidLinks = ref(false);
const placesWithCid = computed(() => {
  return dane.value.filter((item) => item.cid && item.gid);
});

const toggleCidLinks = () => {
  showCidLinks.value = !showCidLinks.value;
};

const sortState = reactive({
  id: { ascending: true },
  title: { ascending: true },
  city: { ascending: true },
  author: { ascending: true },
  videoid: { ascending: true },
  publishedat: { ascending: true },
  haslandingpage: { ascending: true },
  timestamp: { ascending: true },
  isMuala: { ascending: true },
  type: { ascending: true },
});

function parseStringToArray(string) {
  try {
    return JSON.parse(string);
  } catch (e) {
    console.error("Parsing error:", e);
    return []; // Zwraca pustą tablicę w przypadku błędu
  }
}

const sortBy = (key) => {
  // Przełączanie kierunku sortowania dla danej kolumny
  sortState[key].ascending = !sortState[key].ascending;

  // Wykonanie sortowania
  dane.value.sort((a, b) => {
    if (a[key] < b[key]) {
      return sortState[key].ascending ? -1 : 1;
    }
    if (a[key] > b[key]) {
      return sortState[key].ascending ? 1 : -1;
    }
    return 0;
  });
};

onMounted(async () => {
  try {
    const response = await apiFetch("/api/dane");
    if (response.ok) {
      const data = await response.json();
      dane.value = data.data;
      sortBy("publishedat");
      // groups.value = Array.from(new Set(data.data.map(item => item.tagGroup))).sort();
    } else {
      throw new Error("Problem z pobraniem danych");
    }
  } catch (error) {
    console.error(error);
  }
});

const fetchReviews = async (id) => {
  try {
    const response = await apiFetch(`/api/reviews/${id}`);
    if (response.ok) {
      const data = await response.json();
      const reviews = (data?.data || []).reverse();
      return reviews;
    } else {
      console.warn(`fetchReviews(${id}) -> ${response.status}. Treating as no reviews.`);
      return [];
    }
  } catch (error) {
    console.warn(`fetchReviews(${id}) failed:`, error);
    return [];
  }
};

const fetchArticle = async (id) => {
  console.log("dane.value", dane.value);
  try {
    const response = await apiFetch(`/api/article/${id}`);
    if (response.ok) {
      const data = await response.json();
      console.log("fetchArticle:", data.data);
      const reviews = data.data.reverse();
      console.log(reviews);
      return reviews;
    } else {
      throw new Error("Problem z pobraniem danych Article");
    }
  } catch (error) {
    console.error(error);
  }
};


const fetchAllArticles = async (id) => {
  try {
    const response = await apiFetch(`/api/article/`);
    if (response.ok) {
      const data = await response.json();
      console.log("fetchAllArticle:", data.data);
      const reviews = data.data.reverse();
      console.log(reviews);
      return reviews;
    } else {
      throw new Error("Problem z pobraniem danych Article");
    }
  } catch (error) {
    console.error(error);
  }
};


const exportToFirebase = async () => {
  console.log("exportToFirebase");
  // for (const item of dane.value.splice(0, 2)) {
  for (const item of dane.value) {
    const documentId = item.id.toString();
    const reviews = await fetchReviews(item.id);
    const latitude = item.lat;
    const longitude = item.lng;

    console.log("Document ID:", documentId);
    // console.log("Item:", item);
    // console.log("Reviews:", reviews);
    // console.log("Latitude:", latitude);
    // console.log("Longitude:", longitude);

    // Klucze do usunięcia
    let keysToRemove = [
      "id",
      "lat",
      "lng",
      "videoId",
      "author",
      "opis",
      "shortDesc",
      "timestamp",
    ];

    // Usuwanie kluczy z obiektu
    keysToRemove.forEach((key) => {
      delete item[key];
    });

    // Przygotowanie danych
    item.type = JSON.parse(item.type);
    item.position = {
      latitude: latitude,
      longitude: longitude,
    };

    const preparedData = {
      ...item,
      reviews: reviews,
    };

    console.log("Prepared data:", preparedData);

    await addDocumentWithId("places", documentId, preparedData);
  }
};





const exportArticlesToFirebase = async () => {

  const articles = await fetchAllArticles();
  // const firstFiveArticles = articles.slice(0, 5);

  console.log("exportArticlesToFirebase");
  // for (const item of dane.value.splice(0, 2)) {
  for (const item of articles) {


    const parsedData = JSON.parse(item.json);

// Odczytanie wartości "filename"
    const url = parsedData.filename;
    const documentId = item.id.toString();
    const city = await item.city;
    const editDate = item.editDate;
    const json = item.json;
    const placeId = item.placeId;
    const type = item.type;
    const videoid = item.videoid;

    

    console.log("Document ID:", documentId);

  
    const preparedData = {
      city: city,
      editDate: editDate,
      json: json,
      placeId: placeId,
      type: type,
      videoid: videoid,
      url: url,
    };

    console.log("Prepared data:", preparedData);

    await addDocumentWithId("articles", documentId, preparedData);
  }
};




const printAllArticles = async () => {

const articles = await fetchAllArticles();
// const firstFiveArticles = articles.slice(0, 5);

let allArticles = [];
console.log("printAllArticles");
// for (const item of dane.value.splice(0, 2)) {
for (const item of articles) {


  const parsedData = JSON.parse(item.json);

// Odczytanie wartości "filename"
  const url = parsedData.filename;
  const documentId = item.id.toString();
  const city = await item.city;
  const editDate = item.editDate;
  const json = item.json;
  const placeId = item.placeId;
  const type = item.type;
  const videoid = item.videoid;

  

  // console.log("Document ID:", documentId);


  const preparedData = {
    city: city,
    editDate: editDate,
    json: json,
    placeId: placeId,
    type: type,
    videoid: videoid,
    url: url,
  };

  // console.log("Prepared data:", preparedData);
  allArticles.push(preparedData);

}
console.log("allArticles:", allArticles);
};




const ensureLoggedInOrAbort = () => {
  if (!auth.currentUser) {
    alert("Zaloguj się do Firebase, aby wykonać eksport.");
    return false;
  }
  return true;
};

const exportAllInOneToFirebase = async () => {
  if (!ensureLoggedInOrAbort()) return;
  await exportDataToFirebase(dane.value);
};

const exportFilteredToFirebase = async (authors) => {
  if (!ensureLoggedInOrAbort()) return;
  const filteredData = [];
  for (const item of dane.value) {
    const reviews = await fetchReviews(item.id);
    if (reviews && reviews.some(review => authors.includes(review.author))) {
      filteredData.push(item);
    }
  }
  await exportDataToFirebase(filteredData, authors);
};

const exportDataToFirebase = async (dataToExport, authorsFilter = null) => {
  console.log("exportToFirebase");
  
  isExporting.value = true;
  currentProgress.value = 0;
  totalItems.value = dataToExport.length;
  currentItemTitle.value = '';

  let data = {
    all: {},
  };

  for (const item of dataToExport) {
    try {
      currentItemTitle.value = item.title || `Item ${item.id}`;
      currentProgress.value++;
      
      const documentId = item.id.toString();
      const reviewsRaw = await fetchReviews(item.id);
      const latitude = item.lat;
      const longitude = item.lng;

      console.log(`Checking GID for item ${item.id}:`, item.gid);

      const filteredReviews = authorsFilter && Array.isArray(authorsFilter)
        ? (reviewsRaw || []).filter(review => authorsFilter.includes(review.author))
        : (reviewsRaw || []);

      const mappedReviews = filteredReviews ? filteredReviews.map(review => ({
        id: review.id,
        shortDesc: review.shortdesc || '',
        text: review.text || '',
        author: review.author || 'ksiazulo',
        videoId: review.videoid || '',
        timestamp: review.timestamp,
        publishedAt: review.publishedat || '',
        placeId: review.placeid || ''
      })) : [];

      const preparedData = {
        id: documentId,
        title: item.title || '',
        city: item.city || '',
        street: item.street || '',
        cid: item.cid || '',
        gid: item.gid || '',
        position: {
          latitude: latitude || 0,
          longitude: longitude || 0,
        },
        isMuala: item.isMuala || item.ismuala || false,
        publishedAt: item.publishedat || item.publishedAt || new Date().toISOString().split('T')[0],
        ratingValue: item.ratingValue || item.ratingvalue || null,
        url_pyszne: item.url_pyszne || '',
        type: item.type ? parseStringToArray(item.type) : [],
        reviews: mappedReviews,
      };

      data.all[documentId] = preparedData;
      console.log(`Prepared data for ${documentId}:`, preparedData);
    } catch (error) {
      console.error(`Error processing item ${item.id}:`, error);
    }
  }
  
  isExporting.value = false;
  currentProgress.value = 0;
  currentItemTitle.value = '';
  
  console.log("----------");
  console.log("data prepared for Firebase write:", data);

  const result = await addDocumentWithId("data", "1", data);
  if (result?.error?.value) {
    alert(`Błąd zapisu do Firebase: ${result.error.value}. Upewnij się, że masz połączenie z siecią i jesteś zalogowany.`);
  } else {
    alert("Eksport zakończony – dane zapisane w Firebase (kolekcja 'data', dokument '1').");
  }
};


const getTestDocument = async () => {
  console.log("getTestDocument");
  // const doc = await getDocById('places', '248');
  const doc = await getDocById("data", "0");

  console.log(doc);
};

// const getPlaceDetails = async(placeId) => {
//   const request = {
//     placeId: placeId,
//     fields: [
//       "name",
//       "rating",
//       "formatted_phone_number",
//       "geometry",
//       "business_status",
//       "address_components",
//       "formatted_address",
//       "formatted_phone_number",
//       "plus_code",
//       "icon",
//       "opening_hours",
//       "photos",
//       "place_id",
//       "reviews",
//       "types",
//       "url",
//       "vicinity",
//       "website",
//       "price_level",
//       "international_phone_number",
//       "adr_address",
//       "scope",
//       "user_ratings_total",
//       "utc_offset_minutes",
//       "url",
//       "serves_beer",
//       "serves_breakfast",
//       "serves_brunch",
//       "serves_dinner",
//       "serves_lunch",
//       "serves_vegetarian_food",
//       "serves_wine",
//       "takeout",
//       "editorial_summary",
//       "dine_in",
//       "delivery",
//     ],
//   };

//   const service = new google.maps.places.PlacesService(map.value);
//   service.getDetails(request, function (place, status) {
//     if (status === google.maps.places.PlacesServiceStatus.OK) {
//       // console.log("Place details:", place);
//        ;
//       console.log("placeDetailsFull.value: ", placeDetailsFull.value);
//       return place;
//       // createMarker(place); // Załóżmy, że createMarker jest już zdefiniowaną funkcją.
//     } else {
//       console.error("Place details request failed due to ", status);
//     }
//   });
// }

const getPlaceDetails = async (placeId) => {
  const request = {
    placeId: placeId,
    fields: [
      "name",
      "rating",
      "formatted_phone_number",
      "geometry",
      "business_status",
      "address_components",
      "formatted_address",
      "formatted_phone_number",
      "plus_code",
      "icon",
      "opening_hours",
      "photos",
      "place_id",
      "reviews",
      "types",
      "url",
      "vicinity",
      "website",
      "price_level",
      "international_phone_number",
      "adr_address",
      "scope",
      "user_ratings_total",
      "utc_offset_minutes",
      "serves_beer",
      "serves_breakfast",
      "serves_brunch",
      "serves_dinner",
      "serves_lunch",
      "serves_vegetarian_food",
      "serves_wine",
      "takeout",
      "editorial_summary",
      "dine_in",
      "delivery",
    ],
  };

  const service = new google.maps.places.PlacesService(
    document.createElement("div")
  );

  return new Promise((resolve, reject) => {
    service.getDetails(request, function (place, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        resolve(place);
      } else {
        reject(`Place details request failed due to ${status}`);
      }
    });
  });
};

const getAllSavedToFirebase = async () => {
  console.log("getTestDocument");
  const doc = await getDocById("data", "1");
  console.log(doc);
};

const saveTag = async (item) => {
  try {
    const daneDoWyslania = {
      title: item.title,
      city: item.city,
      author: item.author,
      videoid: item.videoid,
      publishedat: item.publishedat,
      timestamp: item.timestamp || null,
      type: typeof item.type === 'string' ? item.type : JSON.stringify(item.type),
      haslandingpage: !!item.haslandingpage,
      ismuala: !!item.ismuala,
      isgroup: !!item.isgroup,
      gid: item.gid,
      cid: item.cid,
      url_pyszne: item.url_pyszne,
      ratingvalue: item.ratingValue,
      reviewcount: item.reviewCount,
      street: item.street,
      postcode: item.postcode,
      status: item.status,
    };

    console.log("saveTag daneDoWyslania", daneDoWyslania);

    const response = await apiFetch(
      `/api/dane/${item.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(daneDoWyslania),
      }
    );
    if (response.ok) {
      console.log("SAVED!");
    } else {
      throw new Error("Problem z zapisem danych");
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const updateRatingsLogic = async (itemsToProcess) => {
  isUpdatingRatings.value = true;
  ratingsUpdateProgress.value = 0;
  ratingsUpdateTotal.value = itemsToProcess.length;
  ratingsUpdateCurrentItem.value = '';

  for (const item of itemsToProcess) {
    try {
      ratingsUpdateCurrentItem.value = item.title || `Item ${item.id}`;
      ratingsUpdateProgress.value++;

      const placeId = item.gid;
      const placeDetails = await getPlaceDetails(placeId);
      console.log("placeDetails:", placeDetails);

      if (placeDetails && placeDetails.url) {
        const urlParts = placeDetails.url.split("=");
        if (urlParts.length > 1) {
          item.cid = urlParts[1];
        }
      }

      item.ratingValue = placeDetails.rating;
      item.reviewCount = placeDetails.user_ratings_total;

      console.log("item:", item);
      await saveTag(item);
    } catch (error) {
      console.error(`Error processing item ${item.id} (${item.title}):`, error);
    }
  }

  isUpdatingRatings.value = false;
  ratingsUpdateProgress.value = 0;
  ratingsUpdateCurrentItem.value = '';
};

const updateGoogleRatings = async () => {
  console.log("dane.value.length:", dane.value.length);
  const przefiltrowaneDane = dane.value.filter(
    (obj) => obj.gid && obj.gid.startsWith("ChIJ")
  );

  console.log("przefiltrowaneDane:", przefiltrowaneDane);
  console.log("przefiltrowaneDane.length:", przefiltrowaneDane.length);
  await updateRatingsLogic(przefiltrowaneDane);
};

const updateGoogleRatingsTest = async () => {
  const przefiltrowaneDane = dane.value
    .filter((obj) => obj.gid && obj.gid.startsWith("ChIJ"))
    .slice(0, 10);
  
  console.log("Testing with 10 items:", przefiltrowaneDane);
  await updateRatingsLogic(przefiltrowaneDane);
};

// {
//     "postcode": "FL 33135",
//     "shortDesc": null,
//     "author": null,
//     "hasLandingPage": false,
//     "street": "1821 SW 8th St",
//     "opis": null,
//     "isMuala": false,
//     "status": null,
//     "review": [
//         {
//             "author": "ksiazulo",
//             "publishedAt": {
//                 "seconds": 1710972965,
//                 "nanoseconds": 26000000
//             },
//             "text": "dlugi opis",
//             "placeId": 111,
//             "editDate": {
//                 "seconds": 1711041148,
//                 "nanoseconds": 198000000
//             },
//             "shortDesc": "krotki opis",
//             "timestamp": {
//                 "seconds": 1710962194,
//                 "nanoseconds": 66000000
//             },
//             "videoId": "xx2233BB"
//         }
//     ],
//     "editDate": {
//         "seconds": 1711034511,
//         "nanoseconds": 963000000
//     },
//     "title": "El Rey De Las Fritas",
//     "city": "Miami",
//     "country": "USA",
//     "gid": "ChIJuYnp5vu22YgRqjNB5POHQPg",
//     "cid": "17888447201491891114",
//     "isGroup": false,
//     "position": {
//         "latitude": 25.7657983,
//         "longitude": -80.2251618
//     },
//     "type": [
//         "kubańska kuchnia",
//         "fast food"
//     ],
//     "publishedAt": {
//         "seconds": 1710955213,
//         "nanoseconds": 836000000
//     }
// }
</script>
